import { ampelFor } from '../../lib/nachforderungenApi';

/** ISO-Datetime → "YYYY-MM-DD" für <input type="date">. Slicing statt Date-Objekt,
 *  damit die gespeicherte UTC-Mitternacht nicht durch die lokale Zeitzone verschiebt. */
export function toDateInputValue(iso: string | null): string {
  return iso ? iso.slice(0, 10) : '';
}

export function fmtDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d.getTime())
    ? null
    : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Die Frist-Plakette — dieselbe Ampel für alle drei Kartenarten.
 *
 * Eine Frist ist eine Frist: Sie soll überall gleich aussehen, sonst müsste man beim Lesen
 * erst prüfen, woher die Zeile stammt.
 *
 * Bewusst OHNE Datum. Beim Überfliegen zählt nur, ob etwas drängt — das genaue Datum steht
 * aufgeklappt im Frist-Feld, dort, wo man es auch ändern kann. In der Kopfzeile war es
 * Ballast: „überfällig (27.07.2026)" beantwortet keine Frage, die „Überfällig" offenlässt.
 */
export function ampelBadge(frist: string | null): { emoji: string; text: string; cls: string } {
  const a = ampelFor(frist);
  if (a === 'pruefen') return { emoji: '🟡', text: 'Frist prüfen', cls: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300' };
  if (a === 'rot') return { emoji: '🔴', text: 'Überfällig', cls: 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300' };
  // Eigenes Orange statt Rot: „Bald fällig" ist eine Vorwarnung, kein Alarm. Stünde es in
  // Rot, wäre es vom echten Überfällig nicht zu unterscheiden — und das eine Wort, das
  // wirklich drängt, verlöre seine Wirkung.
  if (a === 'orange') return { emoji: '🟠', text: 'Bald fällig', cls: 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300' };
  return { emoji: '🟢', text: 'Im Plan', cls: 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300' };
}
